/**
 * Plays a YouTube video in a full-screen dialog (Views/Shared/YouTubeDialog.cshtml, rendered by
 * the layout). Any `.youtube-video-button` with the video's id in `data-video` (and its name in
 * `data-video-title`) opens it; the
 * embed is created on open and removed on close, so nothing loads from YouTube until then and
 * the video stops when the dialog closes.
 */

import { closeOnDismiss, isPlainClick, trackModal } from "../shared/dialog";

const LABEL = "YouTube Hero Video";

export function startYouTubePlayer(dialog: HTMLDialogElement) {
    const player = dialog.querySelector<HTMLElement>("[data-youtube-player]")!;

    document.addEventListener("click", (event) => {
        const trigger = (event.target as Element).closest<HTMLElement>(
            ".youtube-video-button[data-video]",
        );
        const id = trigger?.dataset.video;
        if (!trigger || !id) {
            return;
        }
        // A link may open its page in a new tab; a button has nowhere else to go.
        const href = trigger instanceof HTMLAnchorElement ? trigger.getAttribute("href") : null;
        if (!isPlainClick(event) && href && !href.startsWith("#")) {
            return;
        }
        event.preventDefault();
        const frame = document.createElement("iframe");
        frame.src = `https://www.youtube.com/embed/${encodeURIComponent(id)}?autoplay=1&rel=0`;
        frame.title = trigger.dataset.videoTitle || "YouTube";
        frame.allow = "autoplay; encrypted-media; fullscreen; picture-in-picture";
        frame.allowFullscreen = true;
        player.replaceChildren(frame);
        dialog.showModal();
        trackModal("Open", LABEL);
    });

    dialog.addEventListener("close", () => {
        player.replaceChildren();
        trackModal("Close", LABEL);
    });
    closeOnDismiss(dialog, "[data-youtube-close]", (event) => event.target === dialog);
}
